import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20wallpaper%20with%20warm%20coral%20and%20amber%20smoke%20blending%20over%20deep%20espresso%20brown%20background%2C%20soft%20flowing%20light%20streaks%2C%20dramatic%20cinematic%20texture%2C%20moody%20atmospheric%20editorial%20composition%2C%20no%20text&width=1920&height=1080&seq=fengjian-hero-2026&orientation=landscape"
          alt="风间由美黑料八卦情报站主视觉背景"
          title="风间由美黑料八卦情报站"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-950/70 to-secondary-950/85" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-14 pt-16 md:px-8 md:pb-20 md:pt-24">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-primary-950/40 px-3.5 py-1.5 text-xs text-accent-300 backdrop-blur-sm animate-fadeUp">
            <i className="ri-radar-line text-sm" aria-hidden="true" />
            全网吃瓜情报 · 实时整理补档
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-background-50 text-balance animate-fadeUp md:text-6xl">
            风间由美·黑料八卦情报站
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 animate-fadeUp md:text-base">
            个人资料、近况、黑料与八卦爆料集中整理在这里。不用来回切平台，话题、合集与爆料按条归档，
            关注她的吃瓜网友一次就能看个够。
          </p>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2 animate-fadeUp">
            {['风间由美', '黑料', '八卦', '个人资料', '近况', '爆料'].map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur-sm"
              >
                # {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col items-center gap-3 animate-fadeUp sm:flex-row">
            <a
              href="#leaks"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-flashlight-fill" aria-hidden="true" />
              查看最新爆料
            </a>
            <a
              href="#topics"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-hashtag" aria-hidden="true" />
              进入话题墙
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 border-t border-background-50/15 pt-8 md:mt-16 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3 rounded-lg bg-background-50/5 px-4 py-3 backdrop-blur-sm">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500/90 text-primary-950">
                <i className={stat.icon} aria-hidden="true" />
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-xl font-bold text-background-50">
                  {stat.value}
                  <span className="ml-0.5 text-xs font-normal text-background-300">{stat.unit}</span>
                </span>
                <span className="text-xs text-background-300">{stat.label}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}